module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.appClass,
    attrs: {
      "id": "app"
    }
  }, [_c('router-view', {
    key: _vm.$route.path
  }), _vm._v(" "), (_vm.claimModalShow) ? _c('claim-details') : _vm._e(), _vm._v(" "), (_vm.leaderboardModalShow) ? _c('leaderboard-modal') : _vm._e(), _vm._v(" "), (_vm.impersonate === "true") ? _c('div', {
    staticClass: "c-impersonate"
  }, [_c('h2', {
    staticClass: "c-impersonate__title"
  }, [_vm._v("User session")]), _vm._v(" "), _c('p', {
    staticClass: "c-impersonate__username u-force-wrap"
  }, [_vm._v("\n      " + _vm._s(_vm.participant.primary_email) + "\n      "), _c('span', {
    staticClass: "c-impersonate__username__name"
  }, [_vm._v("\n        (" + _vm._s(_vm.participant.first_name) + " " + _vm._s(_vm.participant.last_name) + ")\n      ")])])]) : _vm._e(), _vm._v(" "), _c('simplert', {
    ref: "simplert",
    attrs: {
      "useRadius": false,
      "useIcon": false
    }
  }), _vm._v(" "), _c('portal-target', {
    attrs: {
      "name": "modal"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1a04987c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 515
// module chunks = 1